export default class {
	constructor() {
		this.tabList = ".js-category__tab";
		this.tabItem = ".js-category__tab-item";
		this.tabContentList = ".js-tab-content__list";
		this.tabContentItem = ".js-tab-content__item";
		this.selectHead = '.js-category__head';
		this.selectItems = '.js-category__tab-item';

		this.tabAction();
		this.responsiveAction();
		this.selectAction();
	}
	tabAction() {
		const tabItem = document.querySelectorAll(this.tabItem);
		const tabContItem = document.querySelectorAll(this.tabContentItem);
		if (tabItem) {
			for (let index = 0; index < tabItem.length; index++) {
				tabItem[index].addEventListener('click', tabToggle);
			}
		}
	 function	tabToggle() {
			for (let i = 0; i < tabItem.length; i++) {
				tabItem[i].classList.remove('is-show');
			}
			for (let i = 0; i < tabContItem.length; i++) {
				tabContItem[i].classList.remove('is-show');
			}
			this.classList.add('is-show');

			const aryTabs = Array.prototype.slice.call(tabItem);
			const index = aryTabs.indexOf(this);
			tabContItem[index].classList.add('is-show');

			var tabTitleText = this.innerText;
			document.querySelector('.js-tab-title').innerText = tabTitleText
		}
	}
	responsiveAction() {
		if (this.selectHead) {
			window.addEventListener('resize', () => {
				this.selectAction();
			});
			window.addEventListener('load', () => {
				this.selectAction();
			});
		}
	}
	selectAction() {
		const windowW = parseInt(window.innerWidth);
		if (this.selectHead) {
			if (windowW <= 768) {
				this.clickAction();
			}
		}
	}
	clickAction() {
		if (this.selectHead) {
			const selectItems = document.querySelectorAll(this.selectItems);
			const selectHeadItem = document.querySelector(this.selectHead);
			selectHeadItem.addEventListener('click', () => {
				selectHeadItem.nextElementSibling.classList.add('is-active');
				selectHeadItem.classList.add('is-active');
			});
			selectItems.forEach(el => {
				el.addEventListener('click', () => {
					el.parentNode.classList.remove('is-active');
				});
			});
		}
	}
}